import { gql } from '@apollo/client';

export const PHOTO_ATTACHMENT_QUERY = gql`
  query JobPhotoRecords($jobId: Int!){
    JobPhotoRecords(jobId: $jobId) {
      id
      createdAt
      description
      fileHash
      filename
      showFindings
      viewInPhotoForm
      jobId
      order
      attachmentId
      questionId
      checklistId
      isPrimary
      showAltered
      alteredAttachmentId
      alteredFileName
      tags {
        createdAt
        id
        name
        photoAttachmentId
        tagId
        updatedAt
        version
      }
    }
  }
`;

export const MOBILE_DATA_GEOCOORDINATES_QUERY = gql`
  query JobGeolocations($jobId: Int!){
    JobGeolocations(jobId: $jobId) {
      capturedOn
      createdAt
      id
      jobId
      lat
      long
      updatedAt
    }
  }
`;
